import { PMSCustomizationService } from "../_services/PMSCustomizationService";
import { genericActions } from "../../Everou/_actions/generic.actions";
import { PMSOrganizationCustomizationTemplateStore } from "../_stores/PMSOrganizationCustomizationTemplateStore";
import { LocationCustomizationMapper } from "../../Everou/_mappers/LocationCustomizationMapper";

export const PMSOrganizationCustomizationActions = {
    getTemplate,
    update,
    uploadLogo,
    uploadBackground,
    removeLogo,
    removeBackground,

    _setUploading: PMSOrganizationCustomizationTemplateStore.actionRequest,
};

// The store holds `{uid, customization}` so consumers can tell which
// organization the loaded template belongs to (it is a single slot, not a
// per-organization cache).
function storeValue(organizationUid, serverTemplate) {
    return {
        uid: organizationUid,
        // An organization without a template yet responds with an empty body
        // (handleResponse yields ""): map it to the empty customization.
        customization: LocationCustomizationMapper.serverToLocal(
            serverTemplate || {},
        ),
    };
}

function getTemplate(organizationUid) {
    return async (dispatch, getState) => {
        try {
            await dispatch(genericActions.genericAsyncAction(asyncAction));
        } finally {
            // Re-set whatever is stored so `isRequesting` never stays stuck
            // on true when the fetch fails or expires (it would freeze the
            // upload controls forever).
            dispatch(
                PMSOrganizationCustomizationTemplateStore.actionSet(
                    PMSOrganizationCustomizationTemplateStore.selectorGet(
                        getState(),
                    ) ?? null,
                ),
            );
        }

        async function asyncAction() {
            const response = await PMSCustomizationService.get(organizationUid);
            dispatch(
                PMSOrganizationCustomizationTemplateStore.actionSet(
                    storeValue(organizationUid, response),
                ),
            );
        }
    };
}

function update(organizationUid, accentColor, headerColor) {
    return async (dispatch) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            const response = await PMSCustomizationService.update(
                accentColor,
                headerColor,
                organizationUid,
            );
            dispatch(
                PMSOrganizationCustomizationTemplateStore.actionSet(
                    storeValue(organizationUid, response),
                ),
            );
        }
    };
}

function uploadLogo(organizationUid, image) {
    return async (dispatch) => {
        dispatch(PMSOrganizationCustomizationActions._setUploading());
        await dispatch(
            genericActions.genericAsyncAction(() =>
                PMSCustomizationService.uploadLogo(image, organizationUid),
            ),
        );
        await dispatch(getTemplate(organizationUid));
    };
}

function uploadBackground(organizationUid, image) {
    return async (dispatch) => {
        dispatch(PMSOrganizationCustomizationActions._setUploading());
        await dispatch(
            genericActions.genericAsyncAction(() =>
                PMSCustomizationService.uploadBackground(
                    image,
                    organizationUid,
                ),
            ),
        );
        await dispatch(getTemplate(organizationUid));
    };
}

function removeLogo(organizationUid) {
    return async (dispatch) => {
        dispatch(PMSOrganizationCustomizationActions._setUploading());
        await dispatch(
            genericActions.genericAsyncAction(() =>
                PMSCustomizationService.deleteLogo(organizationUid),
            ),
        );
        await dispatch(getTemplate(organizationUid));
    };
}

function removeBackground(organizationUid) {
    return async (dispatch) => {
        dispatch(PMSOrganizationCustomizationActions._setUploading());
        await dispatch(
            genericActions.genericAsyncAction(() =>
                PMSCustomizationService.deleteBackground(organizationUid),
            ),
        );
        await dispatch(getTemplate(organizationUid));
    };
}
